/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerFindOneQueryResponse, OrganizationsControllerFindOnePathParams, OrganizationsControllerFindOneQueryParams, OrganizationsControllerFindOne400, OrganizationsControllerFindOne401, OrganizationsControllerFindOne403, OrganizationsControllerFindOne404 } from "../../models/organizationsController/OrganizationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { organizationsControllerFindOne } from "../../clients/organizationsService/organizationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const organizationsControllerFindOneQueryKey = (id: OrganizationsControllerFindOnePathParams["id"], params: OrganizationsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/organizations/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type OrganizationsControllerFindOneQueryKey = ReturnType<typeof organizationsControllerFindOneQueryKey>;
export function organizationsControllerFindOneQueryOptions(id: OrganizationsControllerFindOnePathParams["id"], params?: OrganizationsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = organizationsControllerFindOneQueryKey(id, params);
  return queryOptions<OrganizationsControllerFindOneQueryResponse, ResponseErrorConfig<OrganizationsControllerFindOne400 | OrganizationsControllerFindOne401 | OrganizationsControllerFindOne403 | OrganizationsControllerFindOne404>, OrganizationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return organizationsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get organization by id
 * {@link /api/v1/organizations/:id}
 */
export function useOrganizationsControllerFindOne<TData = OrganizationsControllerFindOneQueryResponse, TQueryData = OrganizationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = OrganizationsControllerFindOneQueryKey>(id: OrganizationsControllerFindOnePathParams["id"], params?: OrganizationsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<OrganizationsControllerFindOneQueryResponse, ResponseErrorConfig<OrganizationsControllerFindOne400 | OrganizationsControllerFindOne401 | OrganizationsControllerFindOne403 | OrganizationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? organizationsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...organizationsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<OrganizationsControllerFindOne400 | OrganizationsControllerFindOne401 | OrganizationsControllerFindOne403 | OrganizationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}